import { gql } from '@apollo/client/core';

export const getUserBusinessUnits = gql`
  query getUserBusinessUnits {
    getUserBusinessUnits {
      id
      name
    }
  }
`;
